<template>
  <b-card :header="$t('ScheduleViewTitle')" header-bg-variant="primary"
          header-text-variant="white" class="text-center">
    <b-card-text class="text-left">
      <b-container fluid>
        <div v-if="loading">
          <BlockUI :message="blockuimsg"></BlockUI>
        </div>
        <!-- User Interface controls -->

        <div role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle.accordion-1 variant="info" class="text-left"><strong>{{ $t('Filter') }}</strong></b-button>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>

                <b-card-text>
                  <b-row>
                    <b-col md="4" class="my-1">
                      <label for="filter1">{{ $t('Year') }}</label>
                      <b-input type="number" id="filter1" v-model.number="selectedItem.anio"></b-input>
                    </b-col>
                    <b-col md="4" class="my-1">
                      <label for="filter2">{{ $t('AuditPlanningMonth') }}</label>
                      <b-input type="number" min="1" max="12" id="filter2" v-model="selectedItem.mesPlanificacionAuditoria"></b-input>
                    </b-col>
                    <b-col md="4" class="my-1">
                      <b-form-group id="NormaCertificarGroup" :label="$t('Standardtobecertified')" label-for="inpNormaCertificar">
                        <b-form-select id="inpNormaCertificar" v-model="selectedItem.normaCertificar" class="mb-3"
                                       :options="protocols"
                                       value-field="id"
                                       text-field="text">
                          <template slot="first">
                            <option :value="null"></option>
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col md="4" class="my-1">
                      <b-form-checkbox id="checkbox-33" v-model="selectedItem.revisionTecnicaPlanificacion" name="checkbox-33"> {{ $t('TechnicalReviewPlanning') }}</b-form-checkbox>
                    </b-col>
                    <b-col md="4" class="my-1">
                      <!--Adaptado con _vacios para que sea compatible con qeu muestre los nulles-->
                      <label>{{ $t('ValidationPlanning') }}</label>
                      <b-form-select v-model="selectedItem.validacionPlanificacion_vacios" class="mb-3">
                        <option value="null" selected>{{$t('SelectAnOption')}}</option>
                        <option value="true">{{$t('Yes')}}</option>
                        <option value="false">{{$t('No')}}</option>
                        <option value="empty">{{$t('Empty')}}</option>
                      </b-form-select>
                    </b-col>
                    <b-col md="4" class="my-1">
                      <b-form-checkbox id="checkbox-2" v-model="selectedItem.recoleccion" name="checkbox-2">  {{ $t('Collection') }} </b-form-checkbox>
                    </b-col>
                    <b-col md="4" class="my-1">
                      <b-form-checkbox id="checkbox-3" v-model="selectedItem.manipulacionCampo" name="checkbox-3">{{ $t('FieldHandling') }} </b-form-checkbox>
                    </b-col>
                    <b-col md="4" class="my-1">
                      <b-form-checkbox id="checkbox-4" v-model="selectedItem.centroDeManipulacion" name="checkbox-4"> {{ $t('HandlingCenter') }} </b-form-checkbox>
                    </b-col>
                    <b-col md="4" class="my-1">
                      <b-form-checkbox id="checkbox-5" v-model="selectedItem.almacenamiento" name="checkbox-5">  {{ $t('Storage') }} </b-form-checkbox>
                    </b-col>
                    <b-col md="3" class="my-1">
                      <b-form-group id="EstadoGroup" :label="$t('State')" label-for="inpEstado">
                        <b-form-select id="inpGroup" v-model="selectedItem.estado" class="mb-3"
                                       :options="states"
                                       value-field="id"
                                       text-field="text">
                          <template slot="first">
                            <option :value="null">{{ $t('SelectAnOption') }}</option>
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <!-- <b-col md="3" class="my-1">
                      <label for="filter22"> {{ $t('Technicalreview') }}</label>
                      <b-input type="number" id="filter23" :min="0" v-model="selectedItem.revisionTecnica"></b-input>
                    </b-col> -->
                    <b-col md="3" class="my-1">
                      <label for="filter22"> {{ $t('SeguimientoPlanificacion') }}</label>
                      <b-input type="number" id="filter23" :min="0" max="3" v-model="selectedItem.seguimiento_planificacion"></b-input>
                    </b-col>
                    <b-col md="3" class="my-1">
                      <label for="filter24"> {{ $t('SeguimientoComercial') }}</label>
                      <b-input type="number" id="filter24" :min="0" max="3" v-model.number="selectedItem.seguimiento_comercial"></b-input>
                    </b-col>
                    <b-col md="3" class="my-1">
                      <label for="filter8">{{ $t('Countryoftheaudit') }}</label>
                      <b-form-select id="filter8" v-model="selectedItem.paisAuditoria" class="mb-3"
                                     :options="paises"
                                     value-field="id"
                                     text-field="text"
                                     >
                        <template slot="first">
                          <option :value="null">{{$t('SelectAnOption') }}</option>
                        </template>
                      </b-form-select>
                    </b-col>

                    <b-col md="3" class="my-1">
                      <b-form-checkbox id="checkbox-6" v-model="selectedItem.ultimaRevisionComercial" name="checkbox-5"> {{ $t('LastCommercialReview') }} </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <!--<b-row class="right"><b-button variant="info" @click="onFilter"><strong>Aplicar filtros</strong></b-button></b-row>-->
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

        </div>

        <!-- Main table element -->
        <br />
        <div id="app">
          <b-button :pressed.sync="botonPlanificacion" @click="onVista1" variant="primary">{{ $t('Planning') }}</b-button>
          <b-button :pressed.sync="botonDocumentacion" @click="onVista2" variant="primary">{{ $t('Documentation') }}</b-button>

          <div>
            <b-row class="my-3">
              <b-col md="6">
                <b-form-group label-cols-sm="2" :label="$t('Filter')" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" :placeholder="$t('TypeToSearch')"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">{{ $t('Clean') }}</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6" class="my-1">
                <b-form-group label-cols-sm="3" :label="$t('RowPerPage')" class="mb-0">
                  <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="6" v-if="showDuplicateOffer">
                <b-button :disabled="selectedItems.length != 1" @click="duplicateOffer">{{ $t('Duplicate') }}</b-button>
                <b-button :disabled="selectedItems.length < 1"  @click="onGenerarInforme('S')"> Informe Especial </b-button>
              </b-col>
            </b-row>

            <b-table ref="tabla"
                     responsive
                     striped
                     hover
                     show-empty
                     :items="items"
                     :fields="fields"
                     :current-page="currentPage"
                     :per-page="perPage"
                     :filter="filter"
                     :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDesc"
                     :sort-direction="sortDirection"
                     @filtered="onFiltered">
                    <template slot="check" slot-scope="row">
                      <b-form-checkbox class="mt-1" v-model="selectedItems" :value="row.item"></b-form-checkbox>
                    </template>
                    <template slot="action" slot-scope="row">
                      <b-button size="sm" @click="ShowDetail(row)" class="mr-1">
                        {{ $t('Details') }}
                      </b-button>
                    </template>
            </b-table>

          </div>
          <b-row>
            <b-col md="6" class="my-1">
              <b-pagination v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            class="my-0"></b-pagination>
            </b-col>
            
          </b-row>

        </div>
        <!-- Main table element -->
      </b-container>
    </b-card-text>
  </b-card>


</template>

<script>
  export default {
    constants: {
      GRID_PLANIFICACION: 1,
      GRID_DOCUMENTACION: 2
    },
    data() {
      return {
        checkedItem: null,
        showDuplicateOffer: false,
        selectedItem: {
          id: null,
          anio: null,
          mesPlanificacionAuditoria: null,
          normaCertificar: null,
          revisionTecnicaPlanificacion: null,
          validacionPlanificacion: null,
          recoleccion: null,
          manipulacionCampo: null,
          centroDeManipulacion: null,
          almacenamiento: null,
          revisionTecnica: null,
          seguimiento_planificacion: null,
          paisAuditoria: null,
          vista: null,
          ultimaRevisionComercial: null,
          estado: null,
          validacionPlanificacion_vacios: null,
          seguimiento_comercial: null
        },
        protocols: [],
        groupstandards: [],
        auditChiefs: [],
        typeAudit: [],
        parallelSystems: [],
        parcelarios: [],
        paises: [],
        states:[],
        fields: {
        },
        filtroInforme: {
          ref_protocolo: null,
          oficina_local_kiwa_pais: null,
          tipo_archivo: null,
          nombreArchivo: null
        },
        items: [],
        selectedItems: [],
        collaborators: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 5,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        botonPlanificacion: false,
        botonDocumentacion: false
      }
    },

    computed: {
      lenguaje: function () {
        return this.$i18n.locale;
      },
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
     watch: {
      lenguaje: function (v) {
        // Usado para cambiar el lenguague de los fields de la grilla.
         if (this.botonPlanificacion == true) {

           this.fieldsVista1();

         } else if (this.botonDocumentacion == true) {

           this.fieldsVista2();

         } 
       }
    },
    mounted() {
      // Set the initial number of items
      this.totalRows = this.items.length;
      this.loadData();
    },
    methods: {
       onRowSelected(items) {
        console.clear();
        console.log(items);
        // this.selected = items
      },
      async loadData() {
        this.loading = true;

        try {
          //cargo el combo de estados
          const responseStates = await this.$http.get('api/offerstates/listcombo');
          this.states = responseStates.body.Data;
        } catch (e) {
          this.states = [];
        }

        try {
          //cargo el combo de colaboradores
          const responseColaboradores = await this.$http.get('api/collaborators/listcombo');
          this.collaborators = responseColaboradores.body.Data;
        } catch (e) {
          this.collaborators = [];
        }        

        try {
          //cargo el combo de normas a certificar
          const responseProtocols = await this.$http.get('api/protocols/listcombo');
          this.protocols = responseProtocols.body.Data;
        } catch (e) {
          this.protocols = [];
        }

        try {
          // Cargo el combo de grupo de normas
          const responseGroupStandards = await this.$http.get('/api/groupstandards/listcombo');
          this.groupstandards = responseGroupStandards.body.Data;
        } catch (e) {
          this.groupstandards = [];
        };

        try {
          //cargo el combo de auditor jefe
          const responseAuditChiefs = await this.$http.get('api/users/listauditchiefs');
          this.auditChiefs = responseAuditChiefs.body.Data;
        } catch (e) {
          this.auditChiefs = [];
        }

        // Cargo el combo pais de la auditoria (se usa como Oficina local kiwa)
        try {
          const responseCountry = await this.$http.get('api/countries/listcombo');
          this.paises = responseCountry.body.Data;
        } catch (e) {
          this.paises = [];
        }

        //cargo combo tipo auditoria
        this.typeAudit = [{ id: "1", text: this.$t('Inicial') },
        { id: "2", text: this.$t('Renewal') },
        { id: "3", text: this.$t('Ampliation') },
        { id: "4", text: this.$t('NotAnnouncedSingle') },
        { id: "5", text: this.$t('Tansfer') },
        { id: "6", text: this.$t('Extraordinary') },
        { id: "7", text: this.$t('Addicional') },        
        { id: "8", text: this.$t('Repetition') }];

        //cargo combo sistemas paralelos
        this.parallelSystems = [{ id: "1", text: this.$t('Azzule') },
        { id: "2", text: this.$t('Ecert') },     
        { id: "3", text: this.$t('Crm') }];         

        //cargo combo parcelario
        this.parcelarios = [{ id: "1", text: this.$t('Requested') },
        { id: "2", text: this.$t('Received') },
        { id: "3", text: this.$t('Checked') }];

        this.loading = false;
      },
      /*
       * @method duplicateOffer
       * @description Crea una copia de una oferta seleccionada
       */
      async duplicateOffer() {
        if (this.selectedItems.length == 1) {
          console.log(this.selectedItems[0]);
          const response = await this.$http.post('api/offeritems/duplicate', this.selectedItems[0].id);
          this.checkedItem = null;
          if (response.ok) {
            this.$toasted.show('Se duplicó la oferta correctamente', { theme: 'outline', type: 'success', duration: 5000 });
            this.onVista1();
          }else{
            this.$toasted.show('Error al duplicar la oferta.', { theme: 'outline', type: 'error', duration: 5000 });
          }
          this.selectedItems = [];
        }
      },
      replaceAll(str, find, replace) {
        return str.replace(new RegExp(this.escapeRegExp(find), 'g'), replace);
      },
      escapeRegExp(str) {
        return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
      },
      async onGenerarInforme(tipoArchivo) {

        // Chequear que todos sean del mismo cliente
        var cliente = this.selectedItems[0].cliente;
        var pais = this.selectedItems[0].cliente_pais;
        var mismoCliente = true;
        this.selectedItems.forEach(function (x) {
          console.log(x.cliente);
          if (cliente != x.cliente) {
            mismoCliente = false;
          }
        });

        this.filtroInforme.tipo_archivo = tipoArchivo;
        this.filtroInforme.ref_protocolo = null;
        this.filtroInforme.oficina_local_kiwa_pais = pais;

        var respuestaArchivoHTML = await this.$http.post('api/administrarArchivos/obtencion', this.filtroInforme);

        var informe = respuestaArchivoHTML.body.Message;
        if (informe.includes('html') && mismoCliente==true) {
            informe = this.replaceAll(informe, '#cliente#', cliente);
            var ix = 1;
            var self = this;
            this.selectedItems.forEach(function (x) {
              //console.log(x);
              //console.log(ix +" " +x.norma +" " + x.auditor +" " + x.finicial +" " + x.ffinal +" " + x.horas_planificadas_totales);
              informe = self.replaceAll(informe, '#norma_a_certificar_' + ix.toString() + '#',x.norma );
              informe = self.replaceAll(informe, '#auditor_jefe_' + ix + '#', x.auditor);
              informe = self.replaceAll(informe, '#fecha_inicial_de_auditoria_' + ix + '#', x.finicial);
              informe = self.replaceAll(informe, '#fecha_final_de_auditoria_' + ix + '#', x.ffinal);
              informe = self.replaceAll(informe, '#horas_planificadas_totales_' + ix + '#', x.horas_planificadas_totales);
              ix++;
          });
          
          informe = this.replaceAll(informe, 'undefined', '')
          informe = this.replaceAll(informe, 'null', '')
          informe = informe.replace(/>#.*#</g, '><');
          informe = informe.replace(/#[\w\d\s_]+#/g, '');

          var newWindow = window.open();
          newWindow.document.write(informe);
          newWindow.stop()
        } else {
          if (!mismoCliente) {
            this.$toasted.show('Para generar el informe seleccione ofertas del mismo Cliente.', { theme: 'outline', type: 'danger', duration: 5000 });
          } else {
            this.$toasted.show('No se encontro un archivo acorde al solicitado.', { theme: 'outline', type: 'warning', duration: 5000 });
          }
        }
        this.selectedItems = [];
      },

      /**
       * @method showDetail
       * @description Redirect to detail
       * @param row
       */
      ShowDetail(row) {
        this.openNewTabUrl('02_DetallePlanificacion', { id: row.item.id });
      },
      async onVista1() {
        this.loading = true;
        this.selectedItem.vista = this.GRID_PLANIFICACION;
        this.showDuplicateOffer = true;
        var self = this;
        this.botonPlanificacion = true;
        this.botonDocumentacion = false;
        this.botonCerti = true;
        try {
          await this.onFiltrar();
          var offerItems = this.items;
          offerItems.forEach(function (item) {
            item.finicial = item.finicial ? item.finicial.split('T')[0] : null;
            item.ffinal = item.ffinal ? item.ffinal.split('T')[0] : null;
            item.comunicacion = item.comunicacion ? item.comunicacion.split('T')[0] : null;
            item.caduc = item.caduc ? item.caduc.split('T')[0] : null;
            item.incperiodo = item.incperiodo ? item.incperiodo.split('T')[0] : null;
            item.finperiodo = item.finperiodo ? item.finperiodo.split('T')[0] : null;
            item.revtecplanificacion = item.revtecplanificacion ? 'Sí' : 'No';

            try {
              item.gnormas = self.groupstandards.find(x => x.id == item.gnormas).text;
            } catch (e) {
              item.gnormas = null;
            }

            try {
              item.norma = self.protocols.find(x => x.id == item.norma).text;
            } catch (e) {
              item.norma = null;
            }

            try {
              item.auditor = self.auditChiefs.find(x => x.id == item.auditor).text;
            } catch (e) {
              item.auditor = null;
            }
            
            try {
              item.colaborador_auditor_interno = self.collaborators.find(x => x.id == item.colaborador_auditor_interno).text;
            } catch (e) {
              item.colaborador_auditor_interno = null;
            }

            try {
              item.tauditoria = self.typeAudit.find(x => x.id == item.tauditoria).text;
            } catch (e) {
              item.tauditoria = null;
            }

            try {
              item.sistemas_paralelos = self.parallelSystems.find(x => x.id == item.sistemas_paralelos).text;
            } catch (e) {
              item.sistemas_paralelos = null;
            }

            var variants = {}

            if (item.ecomunica == true) { variants['ecomunica'] = 'success' };

            if (item.vplani == true) { variants['vplani'] = 'success' };
            if (item.vplani == false) { variants['vplani'] = 'danger' };

            if (item.vauto == true) { variants['vauto'] = 'success' };
            if (item.vauto == false) { variants['vauto'] = 'danger' };

            if (item.audit2Tiempos == true) { variants['audit2Tiempos'] = 'success' };
            if (item.audit2Tiempos == false) { variants['audit2Tiempos'] = 'danger' };

            if (item.controlVal == true) { variants['controlVal'] = 'success' };
            if (item.controlVal == false) { variants['controlVal'] = 'danger' };
            
            if (item.revtecplanificacion == true) { variants['revtecplanificacion'] = 'success' };
            if (item.revtecplanificacion == false) { variants['revtecplanificacion'] = 'danger' };

            if (item.seguimiento_planificacion == 2) { variants['cliente'] = 'warning' }
            if (item.seguimiento_planificacion == 3) { variants['cliente'] = 'success' }

            item._cellVariants = variants;
          });
          this.items = offerItems;
        } catch (e) {
          this.items = [];
        }

        this.totalRows = this.items.length;

        this.fieldsVista1();

        this.loading = false;
      },
      async onVista2() {
        this.loading = true;
        this.selectedItem.vista = this.GRID_DOCUMENTACION;
        this.botonPlanificacion = false;
        this.botonDocumentacion = true;
        this.showDuplicateOffer = false;

        var self = this;
        try {
          await this.onFiltrar();
          var offerItems = this.items;
          offerItems.forEach(function (item) {
            item.comunicacion = item.comunicacion ? item.comunicacion.split('T')[0] : null;
            item.caduc = item.caduc ? item.caduc.split('T')[0] : null;
            item.incperiodo = item.incperiodo ? item.incperiodo.split('T')[0] : null;
            item.finperiodo = item.finperiodo ? item.finperiodo.split('T')[0] : null;

            item.docauditor = item.docauditor ? 'Sí' : 'No';
            item.revtecplanificacion = item.revtecplanificacion ? 'Sí' : 'No';

            try {
              item.gnormas = self.groupstandards.find(x => x.id == item.gnormas).text;
            } catch (e) {
              item.gnormas = null;
            }

            try {
              item.colaborador_auditor_interno = self.collaborators.find(x => x.id == item.colaborador_auditor_interno).text;
            } catch (e) {
              item.colaborador_auditor_interno = null;
            }

            try {
              item.norma = self.protocols.find(x => x.id == item.norma).text;
            } catch (e) {
              item.norma = null;
            }

            try {
              item.tauditoria = self.typeAudit.find(x => x.id == item.tauditoria).text;
            } catch (e) {
              item.tauditoria = null;
            }

            try {
              item.parce = self.parcelarios.find(x => x.id == item.parce).text;
            } catch (e) {
              item.parce = null;
            }
            var variants = {}

            if (item.ecomunica == true) { variants['ecomunica'] = 'success' };

            if (item.vplani == true) { variants['vplani'] = 'success' };
            if (item.vplani == false) { variants['vplani'] = 'danger' };

            if (item.vauto == true) { variants['vauto'] = 'success' };
            if (item.vauto == false) { variants['vauto'] = 'danger' };

            if (item.seguimiento_planificacion == 2) { variants['cliente'] = 'warning' }
            if (item.seguimiento_planificacion == 3) { variants['cliente'] = 'success' }

            item._cellVariants = variants;
          });

          this.items = offerItems;
        } catch (e) {
          this.items = [];
        }

        this.totalRows = this.items.length;

        this.fieldsVista2();

        this.loading = false;
      },
      /**
       * @method fieldsVista1
       * @description Carga los campos de la vista1
       * */
      fieldsVista1() {
        this.fields = [
          { key: 'check' },
          { key: 'action', label: this.$t('Details') },
          { key: 'id', label: this.$t('IdOfferItem'), sortable: true, sortDirection: 'desc' },
          { key: 'cliente', label: this.$t('Client'), sortable: true },
          { key: 'anio', label: this.$t('Year'), sortable: true },
          { key: 'mes', label: this.$t('AuditPlanningMonth'), sortable: true },
          { key: 'gnormas', label: this.$t('StandardsGroup'), sortable: true },
          { key: 'norma', label: this.$t('Standardtobecertified'), sortable: true },
          { key: 'tauditoria', label: this.$t('AuditType'), sortable: true },
          { key: 'auditor', label: this.$t('BossAuditor'), sortable: true },
          { key: 'finicial', label: this.$t('AuditInitDate'), sortable: true },
          { key: 'ffinal', label: this.$t('AuditEndDate'), sortable: true },
          { key: 'comunicacion', label: this.$t('AuditCom'), sortable: true },
          { key: 'ecomunica', label: this.$t('SentCom'), sortable: true },
          { key: 'revtecplanificacion', label: this.$t('TechnicalReviewPlanning'), sortable: true },
          { key: 'vplani', label: this.$t('ValidationPlanning'), sortable: true },
          { key: 'vauto', label: this.$t('ValidationAutomatic'), sortable: true },
          { key: 'controlVal', label: this.$t('ControlValidation'), sortable: true },
          { key: 'audit2Tiempos', label: this.$t('TwoTimesAudit'), sortable: true },
          { key: 'caduc', label: this.$t('CertificateExpiration'), sortable: true },
          { key: 'incperiodo', label: this.$t('AuditPeriodStart'), sortable: true },
          { key: 'finperiodo', label: this.$t('AuditPeriodEnd'), sortable: true },
          { key: 'recoleccion', label: this.$t('Collection'), sortable: true },
          { key: 'manipucampo', label: this.$t('FieldHandling'), sortable: true },
          { key: 'centromanip', label: this.$t('HandlingCenter'), sortable: true },
          { key: 'almacena', label: this.$t('Storage'), sortable: true },
          { key: 'vistamani', label: this.$t('ViewManipulation'), sortable: true },
          { key: 'vistacentro', label: this.$t('ViewManipulationCenter'), sortable: true },
          { key: 'vistareco', label: this.$t('ViewCollection'), sortable: true },
          { key: 'sistemas_paralelos', label: this.$t('ParallelSystems'), sortable: true },
          { key: 'colaborador_auditor_interno', label: this.$t('CollaboratorInternalAuditor'), sortable: true },
        ];
      },
      /**
       * @method fieldsVista2
       * @description Carga los campos de la vista2
       * */
      fieldsVista2() {
        this.fields = [
          { key: 'check' },
          { key: 'action', label: this.$t('Details') },
          { key: 'id', label: this.$t('IdOfferItem'), sortable: true, sortDirection: 'desc' },
          { key: 'cliente', label: this.$t('Client'), sortable: true },
          { key: 'anio', label: this.$t('Year'), sortable: true },
          { key: 'mes', label: this.$t('AuditPlanningMonth'), sortable: true },
          { key: 'gnormas', label: this.$t('StandardsGroup'), sortable: true },
          { key: 'norma', label: this.$t('Standardtobecertified'), sortable: true },
          { key: 'tauditoria', label: this.$t('AuditType'), sortable: true },
          { key: 'comunicacion', label: this.$t('AuditCom'), sortable: true },
          { key: 'ecomunica', label: this.$t('SentCom'), sortable: true },
          { key: 'revtecplanificacion', label: this.$t('TechnicalReviewPlanning'), sortable: true },
          { key: 'vplani', label: this.$t('ValidationPlanning'), sortable: true },
          { key: 'vauto', label: this.$t('ValidationAutomatic'), sortable: true },
          { key: 'parce', label: this.$t('parcel'), sortable: true },
          { key: 'exclusion', label: this.$t('ExcludeCollection'), sortable: true },
          { key: 'docauditor', label: this.$t('DocumentToAuditor'), sortable: true },
          { key: 'sap', label: this.$t('SAP'), sortable: true },
          { key: 'caduc', label: this.$t('CertificateExpiration'), sortable: true },
          { key: 'incperiodo', label: this.$t('AuditPeriodStart'), sortable: true },
          { key: 'finperiodo', label: this.$t('AuditPeriodEnd'), sortable: true },
          { key: 'recoleccion', label: this.$t('Collection'), sortable: true },
          { key: 'manipucampo', label: this.$t('FieldHandling'), sortable: true },
          { key: 'centromanip', label: this.$t('HandlingCenter'), sortable: true },
          { key: 'almacena', label: this.$t('Storage'), sortable: true },
          { key: 'vistamani', label: this.$t('ViewManipulation'), sortable: true },
          { key: 'vistacentro', label: this.$t('ViewManipulationCenter'), sortable: true },
          { key: 'vistareco', label: this.$t('ViewCollection'), sortable: true },
          { key: 'colaborador_auditor_interno', label: this.$t('CollaboratorInternalAuditor'), sortable: true },
         
        ];
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      /**
       * @method onFilter
       * @description Al presionar el botón de filtrar
       * */
      async onFiltrar() {
        try {
          // Si hay un string vacío, limpiamos a null
          const self = this;
          Object.keys(this.selectedItem).forEach(function (key, index) {
            if (self.selectedItem[key] === '' || self.selectedItem[key] === false) {
              self.selectedItem[key] = null;
            }
          });
          
          //if (this.selectedItem.vista == this.GRID_PLANIFICACION) {
          //  this.fieldsVista1();
          //} else if (this.selectedItem.vista == this.GRID_DOCUMENTACION) {
          //  this.fieldsVista2();
          //} else {
          //  // Si no tiene tildado ninguna, por defecto vista1
          //  this.fieldsVista1();
          //  this.selectedItem.vista = this.GRID_PLANIFICACION;
          //}

          // Filtramos
         
          const responseItems = await this.$http.post('/api/schedules/filterschedules', this.selectedItem);
          this.items = responseItems.body.Data;
        } catch (e) {
          this.items = [];
        }

        this.totalRows = this.items.length;

      }
    }
  }
</script>
